<template lang="pug">
div
  .data-table
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="customers" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetchingCustomers" :header-props="{ sortIcon: '$yzi-triangle' }")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    offer: {
      required: true,
      type: Object,
      default: (() => {})
    },
  },
  data () {
    return {
      isFetching: false,
      isFetchingCustomers: false,
      pageSize: -1,
      customers: [],
      headers: [
        { value: 'name', text: 'name', class: 'text-table-header'},
        { value: 'ic', text: 'id', class: 'text-table-header'},
        { value: 'phone', text: 'phone', class: 'text-table-header'},
        // { value: 'email', text: 'email', class: 'text-table-header'},
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedStep: 'marketing/getCreateOfferStep',
    }),
  },
  watch: {
    storedStep (val, oldVal) {
      if (val && oldVal === 0) {
        this.fetchCustomers()
      }
    }
  },
  mounted () {
    this.fetchCustomers()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCustomers () {
      this.isFetchingCustomers = true
      let params = {
        fields: 'customers',
        expand: 'customers'
      }
      this.$axios.get(`/marketing/${this.company.slug}/offers/${this.offer.id}`, { params })
        .then(resp => {
          this.customers = resp.data.customers
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingCustomers = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>